import { AiActivityPart, type AiActivityPartType } from 'juneau';
import { useFeatureTranslation } from '@/hooks/useFeatureTranslation';

interface Props {
  part: AiActivityPartType;
}

/**
 * Renders skill activity indicators with frontend-owned wording: the backend
 * only names the activity (metadata.skill + status); i18n decides the label.
 */
export function ActivityPart({ part }: Props) {
  const t = useFeatureTranslation('aiChat');
  const skill = typeof part.metadata?.skill === 'string' ? part.metadata.skill : undefined;

  const key = skill ? `activities.${skill}.${part.status}` : undefined;
  const translated = key ? t(key) : undefined;
  // Missing translation falls back to the server-provided title from the wire.
  const title = translated && translated !== key ? translated : part.title;

  return <AiActivityPart part={{ ...part, title }} />;
}

export function isActivityPart(part: { type: string }): part is AiActivityPartType {
  return part.type === 'activity';
}
